// src/components/LocationSearch/LocationSearch.js
import React, { useEffect, useRef } from 'react';
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react-geo/styles.css';
import '@maplibre/maplibre-gl-geocoder/dist/maplibre-gl-geocoder.css'; // Ensure this is imported
import { createAmplifyGeocoder } from 'maplibre-gl-js-amplify';
import awsExports from '../../aws-exports';
import './LocationSearch.css';

Amplify.configure(awsExports);

const GAINESVILLE = {
  latitude: 29.651634,
  longitude: -82.324829,
};

const LOCATION_SEARCH_CONTAINER = 'geocoder-container';
const ALACHUA_COUNTY_BBOX = [
  -82.80, // minLon (west)
   29.20, // minLat (south)
  -81.90, // maxLon (east)
   30.05, // maxLat (north)
];

const LocationSearch = ({ onResultSelect, setIsLocationConfirmed }) => {
  const geocoderRef = useRef(null);

  useEffect(() => {
    if (!geocoderRef.current) {
      const geocoder = createAmplifyGeocoder({
        //proximity: GAINESVILLE,
        bbox: ALACHUA_COUNTY_BBOX,
        showResultsWhileTyping: true,
        showResultMarkers: { color: '#3FB1CE' },
        popup: true,
      });

      geocoder.addTo(`#${LOCATION_SEARCH_CONTAINER}`);

      geocoder.on('result', (e) => {
        onResultSelect(e.result.place_name);
        setIsLocationConfirmed(true);
        console.log('Selected location:', e.result.place_name);
      });

      geocoderRef.current = geocoder;
    }
  }, [onResultSelect, setIsLocationConfirmed]);

  return (
    <div>
      <div id={LOCATION_SEARCH_CONTAINER} className="location-search-field"></div>
    </div>
  );
};

export default LocationSearch;
